import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class Ashes extends PhysicalThing {
	static key = "Ashes";
	constructor(xy: XY) {
		super(xy, false);
	}

	getZOrder(): number {
		return ZOrder.CARPET_LIKE;
	}

	static deserialize(data: any): Ashes {
		const a = new Ashes(deserializeXY(data.xy));
		a.visualId = data.visualId;
		return a;
	}
}
